<template>
  <v-container class="mt-16">
    <v-row class="mt-5">
      <v-col sm="12" md="5" lg="5" offset-md="1">
        <h2 class="pretopia-head-font pretopia-display-1 mb-3">Pretopia AB</h2>
        <p class="mb-1">{{ $t('contactUs.address') }}: Västra Gryttjesbo 65, 827 92 Ljusdal</p>
        <p class="mb-1">{{ $t('contactUs.email') }}: <a href="mailto:info@pretopia.se">info@pretopia.se</a></p>

        <v-row class="mt-10 mb-10">
          <v-col sm="12">
            <v-card class="d-flex">
              <v-avatar size="146" tile>
                <v-img position="center top" src="images/jenny_gray.jpg"></v-img>
              </v-avatar>
              <div>
                <v-card-title>Jenny Olsson</v-card-title>
                <v-card-subtitle>{{ $t('contactUs.jennySubtitle') }}</v-card-subtitle>
                <v-card-text>
                  <p class="mb-0">{{ $t('contactUs.email') }}: jenny@pretopia.se</p>
                  <p class="mb-0">{{ $t('contactUs.phone') }}: 073-023 48 64</p>
                </v-card-text>
              </div>
            </v-card>
          </v-col>
          <!-- <v-col sm="12">
            <v-card
              class="d-flex"
            >
            <v-avatar
                size="146"
                tile
              >
              <v-img position="center center" src="images/adam_gray.jpg"></v-img>
            </v-avatar>
            <div>
              <v-card-title>Adam Svender</v-card-title>
              <v-card-subtitle>Marknadsansvarig & delägare</v-card-subtitle>
              <v-card-text>
                <p class="mb-0">E-mail: adam@pretopia.se</p>
                <p class="mb-0">Tel: 076-006 08 55</p>
              </v-card-text>
            </div>
            </v-card>
          </v-col> -->
          <v-col sm="12">
            <v-card class="d-flex">
              <v-avatar size="146" tile>
                <v-img position="top center" src="images/micke_gray3.jpg"></v-img>
              </v-avatar>
              <div>
                <v-card-title>Micke Svensson</v-card-title>
                <v-card-subtitle>{{ $t('contactUs.mickeSubtitle') }}</v-card-subtitle>
                <v-card-text>
                  <p class="mb-0">{{ $t('contactUs.email') }}: micke@pretopia.se</p>
                  <p class="mb-0">{{ $t('contactUs.phone') }}: 076-648 76 40</p>
                </v-card-text>
              </div>
            </v-card>
          </v-col>
          <v-col sm="12">
            <v-card class="d-flex">
              <v-avatar size="146" tile>
                <v-img position="center center" src="images/cissi_gray.jpg"></v-img>
              </v-avatar>
              <div>
                <v-card-title>Cecilia Olsson</v-card-title>
                <v-card-subtitle>{{ $t('contactUs.ceciliaSubtitle') }}</v-card-subtitle>
                <v-card-text>
                  <p class="mb-0">{{ $t('contactUs.email') }}: cecilia@pretopia.se</p>
                </v-card-text>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col sm="12" md="5" lg="5" offset-md="1">
        <h2>{{ $t('contactUs.contactForm.title') }}</h2>
        <p>{{ $t('contactUs.contactForm.subtext1') }}</p>
        <p>{{ $t('contactUs.contactForm.subtext2') }}</p>

        <h4 class="mt-5 mb-3">{{ $t('contactUs.contactForm.subtitle') }}</h4>
        <v-card class="pa-5">
          <v-text-field v-model="contact.companyName" :label="$t('contactUs.contactForm.companyName')"></v-text-field>
          <v-text-field v-model="contact.contactName" :label="$t('contactUs.contactForm.name')"></v-text-field>
          <v-text-field v-model="contact.emailPhone" :label="$t('contactUs.contactForm.emailOrPhone')"></v-text-field>
          <v-textarea v-model="contact.message" :label="$t('contactUs.contactForm.message')"></v-textarea>
          <v-btn :loading="sendingMail" :disabled="sendingMail || !isValid" color="primary" @click="sendMail()"
            >{{ $t('contactUs.contactForm.send') }}</v-btn
          >
          <span v-if="showMailSentMessage" class="ml-5 green--text">{{ $t('contactUs.contactForm.thanks') }}</span>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ContactUsService } from '../../services/contactus.service';

export default {
  data() {
    return {
      contact: {},
      sendingMail: false,
      showMailSentMessage: false,
      showMailSendingError: false,
    };
  },

  computed: {
    isValid() {
      return (
        this.contact.emailPhone && this.contact.emailPhone.trim() && this.contact.message && this.contact.message.trim()
      );
    },
  },

  mounted() {
    if (window.scrollTo) {
      window.scrollTo(0, 0);
    }
  },

  methods: {
    sendMail() {
      this.sendingMail = true;
      this.showMailSendingError = false;
      this.showMailSentMessage = false;

      new ContactUsService()
        .sendMail(this.contact)
        .then(() => {
          this.showMailSentMessage = true;
        })
        .catch(() => {
          this.showMailSendingError = true;
        })
        .finally(() => {
          this.sendingMail = false;
          this.contact = {};
        });
    },
  },
};
</script>
